import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { connectState } from '@examdojo/angular/util';
import { IconComponent } from '@examdojo/core/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ButtonComponent } from '@examdojo/core/button';
import { TOPICS_TREE_MODE, TopicsTreeMode } from '../../../topics-tree-mode';
import { AssetTreeSettingsService } from '../../asset-tree-settings.service';
import {
  AssetTreeAdminModeBadgeType,
  AssetTreeBadgeType,
  AssetTreeStudentModeBadgeType,
  BADGE_TYPE_TO_LABEL_KEY,
} from '../asset-tree-toolbar.model';

@UntilDestroy()
@Component({
  selector: 'y42-asset-tree-toolbar-settings',
  templateUrl: './asset-tree-toolbar-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex items-center' },
  imports: [MtxPopoverModule, MatRadioModule, MatTooltipModule, TranslocoPipe, IconComponent, ButtonComponent],
})
export class AssetTreeToolbarSettingsComponent {
  constructor(
    private readonly assetTreeToolbarService: AssetTreeSettingsService,
    @Inject(TOPICS_TREE_MODE) protected readonly topicsTreeMode: TopicsTreeMode,
  ) {}

  @Output() badgeTypeChanged = new EventEmitter<AssetTreeBadgeType>();

  @ViewChildren(MatRadioButton) radioButtons?: QueryList<MatRadioButton>;

  private readonly assetTreeStudentModeBadgeTypes: AssetTreeStudentModeBadgeType[] =
    Object.values(AssetTreeStudentModeBadgeType);

  private readonly assetTreeAdminModeBadgeTypes: AssetTreeAdminModeBadgeType[] =
    Object.values(AssetTreeAdminModeBadgeType);

  readonly badgeTypes =
    this.topicsTreeMode === 'student' ? this.assetTreeStudentModeBadgeTypes : this.assetTreeAdminModeBadgeTypes;

  readonly BadgeTypeToLabelKey = BADGE_TYPE_TO_LABEL_KEY;

  readonly state = connectState({
    selectedItemType: this.assetTreeToolbarService.badgeType$,
  });

  focusActiveRadioButton() {
    this.radioButtons?.forEach((radioButton) => {
      if (radioButton.value === this.state.selectedItemType) {
        radioButton.focus();
      }
    });
  }
}
